import { createFileRoute } from "@tanstack/react-router"
import { ConvertSizeChart } from "modules/settings/components/integrations/shopify/components/ConvertSizeChart"
import { Crumb } from "modules/shared/lib/breadcrumbs"

export const Route = createFileRoute("/_base/_auth/settings/integrations/shopify/SizeChart")({
  component: ConvertSizeChart,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("settings.integrations.shopify.convertSizeChart.title"),
    })
  },
})
